//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class StaticContentService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[StaticContent.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/cms/static-content/create', params || { });
	};

	//GeneratorFlag:[StaticContent.Delete]
	async delete(staticContentId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:staticContentId
		}
	
		return await _server.delete('/cms/static-content/delete', {'params':params})
	};

	//GeneratorFlag:[StaticContent.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/cms/static-content/detail', {'params':params});
	};

	//GeneratorFlag:[StaticContent.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/cms/static-content/list', {'params':params});
	};

	//GeneratorFlag:[StaticContent.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/cms/static-content/update', params || { });
	};

	//GeneratorFlag:[StaticContent.PublicList]
	async publicList(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/cms/static-content/public-list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}